import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type {
  ClientInfoExtended,
  Report,
  ReportConfiguration,
  ReportTemplate,
  ReportType,
} from "../../../../../../../../api/types/svTypes.ts";

type ReportEntity = Report | ReportTemplate;

export interface VisualizationContextType {
  report: ReportEntity;
  editDisabled: boolean;
  isReportChanged: boolean;
  showUnsavedTooltip: boolean;
  showSaveDialog: boolean;
  isConfigurationEmpty: boolean | undefined;
  unsavedChangesPopoverAnchor: HTMLButtonElement | undefined;
  companies: ClientInfoExtended[];
  onCloseSaveChanges: () => void;
  onSaveChangesSaved: (report: ReportEntity) => void;
  onSaveChange: () => Promise<void>;
  onCloseUnsavedChanges: () => void;
  onContinueUnsavedChanges: () => void;
  onReportTypeClicked: (newType: ReportType, ref: HTMLButtonElement | null) => void;
  getCurrentReportConfigurationAsync: () => Promise<ReportConfiguration | undefined>;
}

export const VisualizationContext = createContext<VisualizationContextType | undefined>(undefined);

export const useVisualizationContext = () => {
  const context = use(VisualizationContext);
  return defined(context);
};
